export default "__VITE_ASSET__Cj$iEjdJ__"